var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getAppointments } from 'shared/graphql/queries';
var getPage = function (userId, request, offset, scopeCreatedAt) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, request(getAppointments, {
                booking_user_id: userId,
                starting_after: scopeCreatedAt,
                limit: 100,
                offset: offset,
                sort_by: [
                    {
                        column: 'appointments.start_at',
                        direction: 'desc',
                    },
                ],
            })];
    });
}); };
export var getAllPagesOfAppointments = function (userId, providerId, request, scopeCreatedAt) { return __awaiter(void 0, void 0, void 0, function () {
    var firstCall, paging, subsCall;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getPage(userId, request, 0, scopeCreatedAt)];
            case 1:
                firstCall = _b.sent();
                paging = firstCall.appointments.paging;
                _b.label = 2;
            case 2:
                if (!(paging.page < paging.pages)) return [3 /*break*/, 4];
                return [4 /*yield*/, getPage(userId, request, paging.page * paging.limit, scopeCreatedAt)];
            case 3:
                subsCall = _b.sent();
                paging = subsCall.appointments.paging;
                (_a = firstCall.appointments.data).push.apply(_a, subsCall.appointments.data);
                return [3 /*break*/, 2];
            case 4: return [2 /*return*/, {
                    userId: userId,
                    providerId: providerId,
                    appointments: firstCall.appointments.data.map(function (ra) {
                        var _a, _b, _c, _d;
                        return ({
                            id: ra.id,
                            start_at: ra.start_at,
                            kind: ra.kind,
                            status: ra.status,
                            medium: ra.medium,
                            member: (_d = (_c = (_b = (_a = ra.bookings) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.role === 'Member'; })) === null || _b === void 0 ? void 0 : _b.calendar) === null || _c === void 0 ? void 0 : _c.user) === null || _d === void 0 ? void 0 : _d.member,
                            care_provider: (function () {
                                var _a, _b, _c, _d;
                                var providerUser = (_c = (_b = (_a = ra.bookings) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.role !== 'Member'; })) === null || _b === void 0 ? void 0 : _b.calendar) === null || _c === void 0 ? void 0 : _c.user;
                                return __assign(__assign({}, ((_d = providerUser === null || providerUser === void 0 ? void 0 : providerUser.care_provider) !== null && _d !== void 0 ? _d : {})), { userId: providerUser === null || providerUser === void 0 ? void 0 : providerUser.id, userRoles: providerUser === null || providerUser === void 0 ? void 0 : providerUser.roles });
                            })(),
                        });
                    }),
                }];
        }
    });
}); };
